"use client";

import React from "react";
import { motion, useReducedMotion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function RequirementsCTA() {
  const shouldReduceMotion = useReducedMotion();
  return <section id="sectorrequirementscta" data-nav="dark" className="relative overflow-hidden bg-sidebar text-sidebar-foreground py-20 md:py-28 lg:py-32">
      {/* Subtle decorative background glow effects */}
      <div aria-hidden="true" className="pointer-events-none absolute inset-0 overflow-hidden">
        <div className="absolute -top-24 left-1/2 -translate-x-1/2 size-96 rounded-full bg-primary/10 blur-3xl" />
        <div className="absolute -bottom-24 right-1/4 size-80 rounded-full bg-chart-3/10 blur-3xl" />
      </div>

      <div className="page-container relative z-10">
        <div className="mx-auto max-w-4xl text-center">
          <motion.h2 initial={shouldReduceMotion ? {
          opacity: 1
        } : {
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.55,
          delay: 0.1,
          ease: "easeOut"
        }} className="font-default text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold tracking-tight text-sidebar-foreground leading-tight md:leading-tight">
            Discuss your application
          </motion.h2>

          <motion.p initial={shouldReduceMotion ? {
          opacity: 1
        } : {
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.55,
          delay: 0.2,
          ease: "easeOut"
        }} className="mx-auto mt-6 max-w-2xl text-base sm:text-lg text-sidebar-foreground/80 leading-relaxed font-sans">
            Tell us about your analytical, manufacturing or field-identification requirement and we will help determine the appropriate technology and next step.
          </motion.p>

          <motion.div initial={shouldReduceMotion ? {
          opacity: 1
        } : {
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.55,
          delay: 0.3,
          ease: "easeOut"
        }} className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-4">
            <Button asChild size="lg" className="h-12 px-8 rounded-md bg-primary text-primary-foreground font-semibold shadow-lg hover:bg-primary/90 transition-all group w-full sm:w-auto">
              <Link to="/DiscussYourApplicationPage" className="flex items-center justify-center gap-2">
                <span>Discuss Your Application</span>
                <ArrowRight className="size-4 transition-transform group-hover:translate-x-1" />
              </Link>
            </Button>
          </motion.div>
        </div>
      </div>
    </section>;
}